export const SALES_METHOD = {
  // Total 29 Sales Methods LAST UPDATED 01-11-2026
  // Active Events (always on top)
  LIVE: 'Live',
  BC_WA_COMMUNITY: 'BC WA Community',
  IG_CHANNEL: 'IG Channel',
  WA_CARI_BARANG: 'WA Cari Barang',
  CATALOGUE_WEB: 'Catalogue Web',
  CATALOG_IG_FEEDS: '(M) Catalogue IG Feeds',
  CONTENT_MTEN: '(M) Content di Mten',
  IG_CONTENT_REELS_UNBOXING: 'IG Content - (M) Reels Unboxing',
  IG_STORY_TRY_ON_COLLAGE_4: 'IG Story - (M) Try on (collage 4)',
  IG_STORY_CONTENT_POJOK_KERAMAT: 'IG Story - content pojok keramat',
  IG_STORY_REF_PIC: 'IG Story - Ref Pic (foto dari Pinterest)',
  IG_STORY_STACKED_ITEMS: 'IG Story - Foto2 barang ditumpuk banyak',
  IG_STORY_CATALOGUE_3_RAK: 'IG STORY - WA ME 3 Rak Full',
  IG_STORY_WA_ME_RACK: 'IG STORY - WA ME Tas Di Rak (isi 1-2 tas)',
  DEAL_OF_THE_WEEK: '(M) Deal of the Week',
  HOME_SHOPPING: 'Home Shopping',
  IN_STORE_BROWSING: 'In-store Browsing',
  STORY_CLASSIC: 'Story Classic',
  STORY_EXOTIC: 'Story Exotic',
  STORY_TELLING: 'Story Telling',
  OFFERING_ONLINE: 'Tawarin Barang - Online',
  STORY_DI_WHATSAPP: 'Story di Whatsapp',
  WALK_IN: 'Walk In',
  CONTENT_INFLUENCER: '(M) Content Influencer',
  EVENT: '(M) Event',
  TRADE: 'Trade',
  ADS: '(M) Ads',
  DM_IG: 'DM IG',
  COLLAGE_OF_4_PHOTOS: 'Collage of 4 photos'
}

const normalizeSalesMethodSortLabel = (value = '') =>
  value.replace(/^\(M\)\s*/i, '').trim()

// Create Deal Ready / PO only: keep the dropdown alphabetically ordered
// without changing the canonical SALES_METHOD values stored in the backend.
export const SALES_METHOD_CREATE_OPTIONS = Object.entries(SALES_METHOD)
  .sort(([, left], [, right]) =>
    normalizeSalesMethodSortLabel(left).localeCompare(
      normalizeSalesMethodSortLabel(right),
      'en',
      { sensitivity: 'base' }
    )
  )
  .reduce((options, [key, value]) => {
    options[key] = value
    return options
  }, {})

export const FINANCE_SALES_METHOD = {
  // Total 52 Sales Methods LAST UPDATED 01-11-2026 (PLUS BACKUP LEGACY& PAST EVENTS Sales Methods)
  // Events (always on top)
  EVENT_NOTTA: 'Event Notta',
  WAREHOUSE_SALE: 'Warehouse Sale',
  WH_SALE_FEB_2026: 'WH Sale Feb 2026',
  WH_SALE_AUGUST_2026: 'WH Sale August 2026',
  LIVE: 'Live',
  BC_TELE: 'BC TELE',
  BC_WA_COMMUNITY: 'BC WA Community',
  CARI_BARANG: 'Cari Barang',
  WA_CARI_BARANG: 'WA Cari Barang',
  CATALOG_IG: 'Catalog IG',
  CATALOG_IG_FEEDS: '(M) Catalogue IG Feeds',
  CATALOG_WEB: 'Catalog Web',
  CATALOGUE_WEB: 'Catalogue Web',
  CONTENT_MTEN: '(M) Content di Mten',
  IG_CONTENT_UNBOXING: 'IG Content - Unboxing',
  IG_CONTENT_REELS_UNBOXING: 'IG Content - (M) Reels Unboxing',
  IG_CHANNEL: 'IG Channel',
  IG_CONTENT_RACK_CATALOG: 'IG Content - Catalogue di Rak',
  IG_CONTENT_REF_PICT: 'IG Content - Ref Pict',
  IG_CONTENT_STORE_PHOTO: 'IG Content - Foto di Toko',
  IG_CONTENT_TRY_ON: 'IG Content - Try On',
  IG_STORY_TRY_ON_COLLAGE_4: 'IG Story - (M) Try on (collage 4)',
  IG_STORY_CONTENT_POJOK_KERAMAT: 'IG Story - content pojok keramat',
  IG_STORY_REF_PIC: 'IG Story - Ref Pic (foto dari Pinterest)',
  IG_STORY_STACKED_ITEMS: 'IG Story - Foto2 barang ditumpuk banyak',
  IG_STORY_CATALOGUE_3_RAK: 'IG STORY - WA ME 3 Rak Full',
  IG_STORY_WA_ME: 'IG Story - WA ME',
  IG_STORY_WA_ME_RACK: 'IG STORY - WA ME Tas Di Rak (isi 1-2 tas)',
  DEAL_OF_THE_WEEK_LEGACY: 'Deal of the Week',
  DEAL_OF_THE_WEEK: '(M) Deal of the Week',
  HOME_SHOPPING: 'Home Shopping',
  IN_STORE_BROWSING: 'In-store Browsing',
  STORY_CLASSIC: 'Story Classic',
  STORY_EXOTIC: 'Story Exotic',
  STORY_TELLING: 'Story Telling',
  OFFERING_OFFLINE: 'Tawarin Barang - Offline',
  OFFERING_ONLINE: 'Tawarin Barang - Online',
  STORY_DI_WHATSAPP: 'Story di whatsapp',
  PRIVATE_VIEWING: 'Private Viewing',
  REGULAR_OFFLINE: 'Regular Offline',
  REGULAR_PURCHASE_OFFLINE: 'Regular Purchase - Offline',
  REGULAR_PURCHASE_ONLINE: 'Regular Purchase - Online',
  SELF_CHECKOUT_ONLINE: 'Self-Checkout Online',
  WALK_IN: 'Walk In',
  WA_STORY: 'WA Story',
  CONTENT_INFLUENCER: '(M) Content Influencer',
  EVENT: '(M) Event',
  TRADE: 'Trade',
  ADS: '(M) Ads',
  DM_IG: 'DM IG',
  COLLAGE_OF_4_PHOTOS: 'Collage of 4 photos'
}

export const SALES_METHOD_NOTE_REQUIRED_METHODS = [
  SALES_METHOD.CONTENT_INFLUENCER,
]

export const SALES_METHOD_NOTE_LABEL_BY_METHOD = {
  [SALES_METHOD.CONTENT_INFLUENCER]: 'Influencer Name',
  [SALES_METHOD.ADS]: 'Ads Marker / Campaign Name',
}

export const SALES_METHOD_FILTER_OPTIONS = [
  { value: '', label: 'All Sales Methods' },
  ...Array.from(new Set(Object.values(FINANCE_SALES_METHOD))).map((value) => ({
    value,
    label: value,
  })),
]

export const AUTHENTICATOR = {
  ENTRUPY : 'Entrupy',
  BABABEBI  : 'Bababebi',
  LEGIT_GRAILS  : 'Legit Grails',
  AUTHENTICATE_FIRST  : 'Authenticate First',
  REAL_AUTHENTICATION  : 'Real Authentication',
}

export const DEAL_STATE = {
  COMPLETED : 'completed',
  ON_DELIVERY : 'on_delivery',
  SOURCED : 'sourced',
  CANCELLED : 'cancelled',
  FAILED : 'failed',
  WAITING_FOR_CONFIRMATION : 'waiting_for_confirmation',
}

export const PAYMENT_METHOD = {
  MANUAL_TRANSFER : 'manual_transfer',
  CASH : 'cash',

  // legacy - keep for backward compatibility
  EDC : 'edc',
  CREDIT_CARD : 'credit_card',
  VIRTUAL_ACCOUNT : 'virtual_account',

  // NEW
  MIDTRANS : 'midtrans',
  EDC_BRI : 'edc_bri',
  EDC_BCA : 'edc_bca',
  SOLD_IN_STORE : 'sold_in_store',
}

export const PAYMENT_METHOD_FILTER_OPTIONS = [
  { value: '', label: 'All Payment Methods' },
  { value: PAYMENT_METHOD.CASH, label: 'Cash' },
  { value: PAYMENT_METHOD.MANUAL_TRANSFER, label: 'Direct Bank Transfer' },
  { value: PAYMENT_METHOD.CREDIT_CARD, label: 'MIDTRANS / Credit Card' },
  { value: PAYMENT_METHOD.VIRTUAL_ACCOUNT, label: 'Virtual Account' },
  { value: PAYMENT_METHOD.EDC, label: 'EDC (Legacy)' },
  { value: PAYMENT_METHOD.EDC_BRI, label: 'EDC BRI' },
  { value: PAYMENT_METHOD.EDC_BCA, label: 'EDC BCA' },
  { value: PAYMENT_METHOD.SOLD_IN_STORE, label: 'Sold in Store' },
]

// NEW: option list khusus Create Deal v2
export const DEAL_PAYMENT_METHOD_OPTIONS = [
  {
    label: 'Cash',
    value: PAYMENT_METHOD.CASH,
    installment: null,
    option_value: PAYMENT_METHOD.CASH,
  },
  {
    label: 'Midtrans (CC) - Non Amex',
    value: PAYMENT_METHOD.CREDIT_CARD,
    installment: null,
    option_value: 'credit_card__non_amex',
    card_type: 'non_amex',
  },
  {
    label: 'Midtrans (CC) - Amex',
    value: PAYMENT_METHOD.CREDIT_CARD,
    installment: null,
    option_value: 'credit_card__amex',
    card_type: 'amex',
  },
  {
    label: 'EDC BRI',
    value: PAYMENT_METHOD.EDC_BRI,
    installment: null,
    option_value: PAYMENT_METHOD.EDC_BRI,
  },
  {
    label: 'EDC BCA',
    value: PAYMENT_METHOD.EDC_BCA,
    installment: null,
    option_value: PAYMENT_METHOD.EDC_BCA,
  },
  {
    label: 'Direct Bank Transfer',
    value: PAYMENT_METHOD.MANUAL_TRANSFER,
    installment: null,
    option_value: PAYMENT_METHOD.MANUAL_TRANSFER,
  },
]

// NEW: dipakai untuk conditional rendering Card Type
export const EDC_PAYMENT_METHODS = [
  PAYMENT_METHOD.EDC_BRI,
  PAYMENT_METHOD.EDC_BCA,
]

export const CARD_TYPE = {
  VISA_MASTERCARD_ON_US  : 'visa_mastercard_on_us',
  VISA_MASTERCARD_OFF_US : 'visa_mastercard_off_us',
  JCB_UNION_PAY          : 'jcb_union_pay',
  AMEX                   : 'amex',
  DEBIT_ON_US            : 'debit_on_us',
  DEBIT_OFF_US           : 'debit_off_us',
}

export const CARD_TYPE_OPTIONS = [
  { value: CARD_TYPE.VISA_MASTERCARD_ON_US,  label: 'Visa/Mastercard on-us' },
  { value: CARD_TYPE.VISA_MASTERCARD_OFF_US, label: 'Visa/Mastercard off-us' },
  { value: CARD_TYPE.JCB_UNION_PAY,          label: 'JCB/Union Pay' },
  { value: CARD_TYPE.AMEX,                   label: 'Amex' },
  { value: CARD_TYPE.DEBIT_ON_US,            label: 'Debit on-us' },
  { value: CARD_TYPE.DEBIT_OFF_US,           label: 'Debit off-us' },
]


export const CREATED_DEAL_BY = {
  ADMIN: 'admin',
  WEB: 'web',
}

export const CREATED_DEAL_BY_LABELS = {
  [CREATED_DEAL_BY.ADMIN]: 'Admin',
  [CREATED_DEAL_BY.WEB]: 'Web',
}

export const CREATED_DEAL_BY_OPTIONS = [
  { value: CREATED_DEAL_BY.ADMIN, label: CREATED_DEAL_BY_LABELS[CREATED_DEAL_BY.ADMIN] },
  { value: CREATED_DEAL_BY.WEB, label: CREATED_DEAL_BY_LABELS[CREATED_DEAL_BY.WEB] },
]

export const CREATED_DEAL_BY_FILTER_OPTIONS = [
  { value: '', label: 'All Create Deal By' },
  ...CREATED_DEAL_BY_OPTIONS,
]